import { BRAND } from 'config/fe-routes';
import { MouseEvent } from 'react';
import { setGlobalLoader } from 'store/actions/global-loader.actions';
import { brandsChanged } from 'store/actions/search.actions';
import { useAppDispatch } from 'store/hooks';
import { Brand } from 'types/brand.types';
import { toKebabCase } from 'utils/format-text';
import ImageUrlResizer from 'utils/image-url-resizer';

import BrandItem from './BrandItem';

type BrandItemProps = {
  brand: Brand;
  globalLoaderEnabled: boolean;
};

const BrandItemContainer = ({ brand, globalLoaderEnabled }: BrandItemProps) => {
  const brandLink = BRAND(toKebabCase(brand?.name));

  const dispatch = useAppDispatch();

  const onClick = (e: MouseEvent) => {
    dispatch(brandsChanged([brand.id]));
    globalLoaderEnabled && setGlobalLoader(true, e);
  };

  const args = {
    href: brandLink.href,
    as: brandLink.as,
    onClick,
    hasImage: !!brand?.image,
    imageSrc: brand?.image && ImageUrlResizer.resize(brand?.image?.original, 150, false, 'png'),
    name: brand?.name,
  };

  return <BrandItem {...args} />;
};

export default BrandItemContainer;
